"use es6";

import { mirrorEasing } from "./modifiers/mirror";
import { reverseEasing } from "./modifiers/reverse";
const circIn = p => 1 - Math.sin(Math.acos(p));
const circOut = reverseEasing(circIn);
const circInOut = mirrorEasing(circIn);
export { circIn, circInOut, circOut };